// 全角数字を半角に変換
const toHalfWidthDigits = (str) =>
    str.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));

// 郵便番号: 半角数字7桁を「123-4567」形式に整形（4桁目以降でハイフンを自動挿入）
const sanitizeZip = (str) => {
    const digits = toHalfWidthDigits(str).replace(/[^0-9]/g, '').slice(0, 7);

    return digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;
};

// 電話番号: 数字とハイフンのみ（全角ハイフン・長音などは半角ハイフンに統一）
const sanitizeTel = (str) =>
    toHalfWidthDigits(str)
        .replace(/[‐‑‒–—―ー－]/g, '-')
        .replace(/[^0-9-]/g, '');

// 電話番号の分割欄: 数字のみ（ハイフンはサーバー側で連結するため入力させない）
const sanitizeDigits = (str) => toHalfWidthDigits(str).replace(/[^0-9]/g, '');

/**
 * 電話番号の3分割入力（tel1 / tel2 / tel3）
 * 各欄を数字のみに整形する
 *
 * 市外局番は3桁（090-）と4桁（0120-）のどちらもあり「桁が埋まった」を判定できないため、
 * 次の欄への自動フォーカス移動は行わない。
 */
const initTelParts = () => {
    document.querySelectorAll('.c-forms-input-tel').forEach((group) => {
        const fields = Array.from(group.querySelectorAll('input[data-tel-part]'));
        if (fields.length === 0) return;

        fields.forEach((field) => {
            field.addEventListener('input', () => {
                const converted = sanitizeDigits(field.value);
                if (converted !== field.value) {
                    field.value = converted;
                }
            });

            field.addEventListener('blur', () => {
                field.value = sanitizeDigits(field.value);
            });

            // ハイフン区切りの番号をまとめて貼り付けたときだけ各欄へ振り分ける
            // （ハイフンなしの連続数字は市外局番の桁数を判別できないため振り分けない）
            field.addEventListener('paste', (event) => {
                const parts = sanitizeTel(event.clipboardData?.getData('text') ?? '').split('-');
                const isFullNumber = parts.length === fields.length
                    && parts.every((part) => /^[0-9]+$/.test(part));

                if (!isFullNumber) return;

                event.preventDefault();
                fields.forEach((target, index) => {
                    target.value = parts[index];
                });
            });
        });
    });
};

const main = () => {
    initTelParts();

    const targets = document.querySelectorAll('input[name="tel"], input[name="zip"]');
    if (!targets.length) return;

    targets.forEach((input) => {
        const sanitize = input.name === 'tel' ? sanitizeTel : sanitizeZip;
        let composing = false;

        // 初期値も整形する（バリデーションエラーで戻った値・旧形式の値に対応）
        if (input.value !== '') {
            input.value = sanitize(input.value);
        }

        input.addEventListener('compositionstart', () => { composing = true; });
        input.addEventListener('compositionend', () => {
            composing = false;
            // compositionend後に整形
            input.value = sanitize(input.value);
        });

        // blurで最終整形（メインのサニタイズ）
        input.addEventListener('blur', () => {
            input.value = sanitize(input.value);
        });

        // inputイベントではIME中はスキップ
        input.addEventListener('input', () => {
            if (composing) return;
            const converted = sanitize(input.value);
            if (converted !== input.value) {
                const pos = input.selectionStart;
                const diff = input.value.length - converted.length;
                input.value = converted;
                input.setSelectionRange(pos - diff, pos - diff);
            }
        });
    });
};

export default main;
